module.exports = __webpack_public_path__ + "dd263098fbf6b548d2032903dc11a785.png";